import * as types from '../const/action.types';
import { get, post } from '../api/_basic';

export function load(id) {
    return async (dispatch) => {
        dispatch(stsHasErrored(false, ''));
        dispatch(stsIsLoading(true));
        dispatch(loadSTSSuccess({}));
        return get(`${process.env.REACT_APP_API_STS}/${id}`)
            .then((response) => {
                dispatch(stsIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(stsHasErrored(false, ''));
                dispatch(loadSTSSuccess(items));
            })
            .catch((error) => {
                dispatch(stsIsLoading(false));
                dispatch(stsHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function send(code, stars, message, captcha) {
    return async (dispatch) => {
        dispatch(stsIsLoading(true));
        const body = {
            puntuacion: stars,
            comentario: message,
            'g-recaptcha-response': captcha,
        };
        return post(`${process.env.REACT_APP_API_STS}/${code}`, body)
            .then((response) => {
                dispatch(stsIsLoading(false));
                return response;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadSTSSuccess(data) {
    return {
        type: types.LOAD_STS_SUCCESS,
        data,
    };
}

export function stsHasErrored(bool, message) {
    return {
        type: types.STS_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function stsIsLoading(bool) {
    return {
        type: types.STS_IS_LOADING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/sts.actions.js